import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { IconButton, Stack } from "@mui/material";
import closeIcon from '../Assets/images/close_red.png';
import { useSelector } from "react-redux";
import { handleValidateCodevalue } from "../Utility/constant";

const BiztantuSearchDialog = ({children,handleReset ,handleSearch , data, handleCloseDialog, maxWidth = "lg"}) => {

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    return (
        <>
        
            <Dialog
                fullWidth={true}
                maxWidth= {maxWidth}
                open={data?.isOpen}
                sx={{borderRadius: "15px"}}
            >
                <DialogTitle style={{display: "flex", justifyContent: "flex-end", padding: "10px"}}>
                    <IconButton
                    >
                        <img onClick={handleCloseDialog} src={closeIcon} style={{height: "35px",}}/>
                    </IconButton>
                </DialogTitle>
                 <DialogContent dividers>
                    {children}
                </DialogContent>
                <DialogActions>
                    <Stack display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} flexDirection={"row"}>
                        <Button className="edit-primary mr-20 btn-search"  autoFocus   onClick={async ()=>{handleSearch();handleCloseDialog()}}>
                                {handleValidateCodevalue(internationalise,'COMMON_SEARCH')}
                        </Button>

                        <Button className="edit-primary ml-20 btn-search reset-btn" onClick={handleReset}>
                                {handleValidateCodevalue(internationalise,'COMMON_RESET')}
                        </Button>
                    </Stack>
                </DialogActions>
      
            </Dialog>
        </>
    )
}

export default BiztantuSearchDialog;